import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from './routes/RequireAuth.jsx';
import ScoreCardPage from './pages/ScoreCardPage.jsx';
import { getSession } from './utils/session.js';

const LoginPage = lazy(() => import('./pages/LoginPage.jsx'));
const DashboardPage = lazy(() => import('./pages/DashboardPage.jsx'));
const NewProjectPage = lazy(() => import('./pages/NewProjectPage.jsx'));
const ProjectDetailsPage = lazy(() => import('./pages/ProjectDetailsPage.jsx'));
const DesignPage = lazy(() => import('./pages/DesignPage.jsx'));
const SolarPanelDatabasePage = lazy(() => import('./pages/SolarPanelDatabasePage.jsx'));

function AppFallback() {
  return (
    <main className="missing-page">
      <h1>Loading...</h1>
    </main>
  );
}

function Protected({ children }) {
  return <RequireAuth>{children}</RequireAuth>;
}

function LazyPage({ children }) {
  return <Suspense fallback={<AppFallback />}>{children}</Suspense>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={getSession() ? '/dashboard' : '/login'} replace />} />
      <Route path="/login" element={<LazyPage><LoginPage /></LazyPage>} />
      <Route path="/dashboard" element={<Protected><LazyPage><DashboardPage /></LazyPage></Protected>} />

      {/* Score Card is deliberately a first-class route in the main bundle. */}
      <Route path="/score-card" element={<Protected><ScoreCardPage /></Protected>} />
      <Route path="/scorecard" element={<Navigate to="/score-card" replace />} />

      <Route path="/projects/new" element={<Protected><LazyPage><NewProjectPage /></LazyPage></Protected>} />
      <Route path="/solar-panels" element={<Protected><LazyPage><SolarPanelDatabasePage /></LazyPage></Protected>} />
      <Route path="/projects/:projectId" element={<Protected><LazyPage><ProjectDetailsPage /></LazyPage></Protected>} />
      <Route path="/design/:designId" element={<Protected><LazyPage><DesignPage /></LazyPage></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
